<template>
  <div>
    <header class="py-4 bg-white">
      <div class="container flex flex-col items-center justify-between mx-auto md:flex-row">
        <div class="flex items-center justify-between w-full md:w-auto">
          <a href="/">
            <img src="/logo.png" alt="Logo Realgestion" class="h-12" />
          </a>
          <button @click="toggleMenu" class="p-2 md:hidden">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path v-if="!isMenuOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
              <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>

        <div class="w-full mt-4 md:mt-0 md:w-auto">
          <search-bar v-model="form.search.terms" :categories="categories" @search="handleSearch" @category="handleCategory" />
        </div>

        <div class="flex items-center mt-4 space-x-4 md:mt-0">
          <!-- Login/Dashboard Button -->
          <button 
            @click="navigateTo(auth ? '/dashboard' : '/login')"
            class="px-4 py-2 font-bold text-darkblue-700 hover:text-darkblue-800 transition-colors duration-200 rounded-lg hover:bg-gray-100"
          >
            {{ auth?.first_name || 'INGRESAR' }}
          </button>

          <!-- Shopping Cart Button -->
          <button
            v-if="auth"
            @click="navigateTo('/web/cart')"
            class="relative p-2 text-darkblue-600 hover:text-darkblue-800 transition-colors duration-200 rounded-lg hover:bg-gray-100"
            aria-label="Shopping Cart"
          >
            <svg 
              class="w-6 h-6" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
              stroke-linecap="round" 
              stroke-linejoin="round" 
              stroke-width="2"
            >
              <path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            
            <!-- Cart Items Counter -->
            <span 
              v-if="cart"
              class="absolute -top-1 -right-1 px-2 py-1 text-xs font-bold text-white bg-blue-800 rounded-full min-w-[20px] text-center"
            >
              {{cart}}
            </span>
          </button>
        </div>
      </div>
    </header>

    <nav :class="['bg-black', 'transition-all', 'duration-300', 'ease-in-out', isMenuOpen ? 'block' : 'hidden md:block']">
      <div class="container mx-auto py-2">
        <ul class="flex flex-col space-y-2 md:flex-row md:justify-center md:space-x-8 md:space-y-0">
          <li><a :href="`/`" class="block px-4 py-2 hover:text-gray-200 text-white font-bold">Inicio</a></li>
          <li v-for="category in categories" :key="category.id">
            <a :href="`/web/products?search[category]=${category.id}`" class="block px-4 py-2 hover:text-gray-200 text-white font-bold">{{ category.name }}</a>
          </li>
        </ul>
      </div>
    </nav>

    <div v-if="balance > 0" class="flex flex-col md:flex-row items-center justify-center p-4 bg-red-500">
      <span class="text-center md:text-left mb-2 md:mb-0 mr-0 md:mr-4 text-white font-medium">Tienes un saldo pendiente de ${{ balance }}. Por favor pagar a la brevedad. Gracias.</span>
      <a href="/web/me" class="w-full md:w-auto px-4 py-2 text-center text-white font-bold bg-blue-800 hover:bg-sky-700 rounded-lg">Haz click aquí</a>
    </div>

    <div v-if="$page.props.flash.success" class="flex items-center justify-center p-2 bg-green-500">
      <span class="text-center text-white font-medium">{{ $page.props.flash.success }}</span>
    </div>
    <div v-if="$page.props.flash.error" class="flex items-center justify-center p-2 bg-yellow-500">
      <span class="text-center text-white font-medium">{{ $page.props.flash.error }}</span>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import SearchBar from './SearchBar.vue'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
export default {
  components: { SearchBar, Link },
  name: 'HeaderWeb',
  props: {
    auth: Object,
    categories: Object,
    client: Object,
    cart: Number,
    balance: Number,
  },
  data() {
    return {
      show: false,
      isMenuOpen: false,
      form: {
        search: {
          terms: '',
          category: '',
        },
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/web/products', pickBy(this.form), { preserveState: true })
      }, 150),
    },
    watch: {
    '$page.props.flash': {
      handler() {
        this.show = true
      },
      deep: true,
    },
  }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    handleCategory(category) {
      this.form.category = category.id
    },
    handleSearch(query, category) {
      console.log('Query:', query)
      console.log('Categoría:', category)
    },
    navigateTo(route)
    {
      this.$inertia.visit(route)
    }
  },
}
</script>
